"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMediaContext = exports.createMediaContextProvider = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var strategies_1 = require("./strategies");
var react_2 = require("@chakra-ui/react");
var MediaContext = (0, react_1.createContext)(null);
function createMediaContextProvider(Component) {
    return function (props) {
        var _a = props.strategy, Strategy = _a === void 0 ? strategies_1.MediaStrategies.Default : _a, _js = props._js, filter = props.filter, siteName = props.siteName, openInUploadView = props.openInUploadView, toast = props.toast;
        var _b = (0, react_1.useState)(openInUploadView ? strategies_1.defaultMediaStrategyStateInUploadView : strategies_1.defaultMediaStrategyState), state = _b[0], setState = _b[1];
        var altToast = (0, react_2.useToast)();
        var strategy = (0, react_1.useMemo)(function () {
            return new Strategy(state, setState, toast !== null && toast !== void 0 ? toast : altToast, {
                _js: _js,
                filter: filter,
                siteName: siteName,
            });
        }, [state]);
        return (React.createElement(MediaContext.Provider, { value: strategy },
            React.createElement(Component, __assign({}, props))));
    };
}
exports.createMediaContextProvider = createMediaContextProvider;
function useMediaContext() {
    var ctx = (0, react_1.useContext)(MediaContext);
    if (!ctx)
        throw Error('Attempted to call "useMediaContext" outside of a "MediaContextProvider"');
    return ctx;
}
exports.useMediaContext = useMediaContext;
